import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Area = styled.textarea`
    width: 100%;
    padding: 12px 14px;
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${colors.surface};
    font-size: 15px;
    line-height: 1.5;
    color: ${colors.textPrimary};
    outline: none;
    resize: vertical;
    font-family: inherit;

    &:focus {
        border-color: ${colors.primary};
    }

    &::placeholder {
        color: ${colors.textSecondary};
    }
`;
